import React from 'react';
import Human from '../../assets/human.png'
import './layout.css'
import Search from '../../assets/Images/search.png'


const Footer = () => {
    return (
        <div id="footer" >

            <div className='my-3' style={{textAlign:"center"}}>
                <span style={{ color: "rgb(77 75 75)", fontSize: 14, fontWeight: 400 }}>
                    © 2024 Tata Steel. All rights reserved.
                </span>
            </div>

        </div>
    );
};

export default Footer;